class ShiftPositionsService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  get(params) {
    return this.apiService.get('/api/v1/avg/shift-positions', params);
  }

  create(params) {
    return this.apiService.post('/api/v1/avg/shift-positions', params);
  }

  update(params) {
    return this.apiService.put(`/api/v1/avg/shift-positions/${params.id}`, params);
  }

  remove(params) {
    return this.apiService.delete('/api/v1/avg/shift-positions', params);
  }
}

export default ShiftPositionsService;
